module.exports = __webpack_public_path__ + "img/allhitoldies.052cbaf3.png";